<ng-container *ngIf="surveyModel$ | async as model">
  <p-dialog
    [(visible)]="visible"
    styleClass="p-dialog-full p-dialog-padding-none"
    [resizable]="false"
    [draggable]="false"
    [blockScroll]="true"
    [closeOnEscape]="closable"
    [closable]="closable"
    [modal]="true"
    closeIcon="fa fa-times"
    appendTo="body"
    [header]="'display-survey.title' | translate"
    (onHide)="onDialogHide()"
  >
    <survey [model]="model"></survey>
  </p-dialog>
</ng-container>
